export enum ActionTypes {
  // base
  SET_LOGGED_USER = 'slash/SET_LOGGED_USER',
  CLEAN_LOGGED_USER = 'slash/CLEAN_LOGGED_USER',
}
